import $ from 'jquery';
import { closest } from 'next/javascripts/modules/dom';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-project-progress-status', {
  mixins: [eventListenerMixin],

  properties: {
    createStatusUrl: String,
    createTodoUrl: String,
  },

  ready() {
    if (window.tower.me) {
      this.initComponents();
    } else {
      $(document).ready(this.initComponents.bind(this));
    }
  },

  connected() {
    this.listenTo(this.querySelector('.tr-dropdown-button'), {
      'tr-menu:selected': this.handleDropdownButtonSelect.bind(this),
      click: this.handleDropdownButtonClick.bind(this),
    });
  },

  initComponents() {
    window.tower.adjustReadableTime($(this));
  },

  handleDropdownButtonClick(event) {
    if (closest(event.target, '.update-status-button')) {
      this.fetchForm(this.createTodoUrl);
    }
  },

  handleDropdownButtonSelect(event) {
    if (event.detail.item.dataset.value === 'update_by_self') {
      this.fetchForm(this.createStatusUrl);
    }
  },

  fetchForm(url) {
    $.ajax({
      url,
      method: 'get',
      dataType: 'script',
    });
  },

  disconnected() {
    this.stopListening();
  },
});
